import { stringEnum } from 'common/utils/objects';

export const INTERNAL_EMAILS = stringEnum([
	'chargeCreditCardEmail',
	'failedToChargeCreditCardEmail',
	'extensionLinkRequest',
]);

export const CUSTOMER_FACING_EMAILS = stringEnum([
	'adminOrderConfirmation',
	'onlineOrderConfirmation',
	'instoreOrderContract',
	'extensionLinkConfirmation',
	'depositReserved',
	'depositReservationFailed',
	'depositCaptured',
]);

export const ALL_EMAILS = { ...INTERNAL_EMAILS, ...CUSTOMER_FACING_EMAILS };
